import { defineComponent as _defineComponent } from 'vue'
import { LoaderIndicator } from '@warrenbrasil/nebraska-web';

interface Props {
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsViewHeroBase',
  props: {
    loading: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,LoaderIndicator }
}

})